import axios from 'axios';
import AuthService from './auth-header';

// /*dev*/const API_URL = 'https://ats.sattvahuman.in/api/';
// /*prod*/ // const API_URL = 'https://ats.sattvahuman.in/api/';


let API_URL = ''
    if (process.env.NODE_ENV === "production") {
        API_URL = 'https://ats.sattvahuman.in/api/'
    } else {
        API_URL = 'http://192.168.0.30:5000/api/'
    }
class clientService {
    normalizeError(err) {
        const body = err?.response?.data
        if (body && typeof body === 'object') return body
        return {
            status: 'FAILED',
            message: err?.message || 'Request failed',
        }
    }

    async create(data) {
        try {
            const res = await axios.post(API_URL + 'jobs/client', data,
                {
                    headers: AuthService.authHeader()
                });
            console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response);
            return this.normalizeError(err);
        }
    }

    async getClients() {
        try {
            const res = await axios.get(API_URL + 'jobs/client',
                {
                    headers: AuthService.authHeader()
                });
            console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response);
            return this.normalizeError(err);
        }
    }

}

export default new clientService();